export const outletCategories = {
  BUTCHER: 'butcher',
  FARM_SHOP: 'farm shop',
  SHOP: 'shop',
  RESTAURANT: 'restaurant',
  ONLINE_RETAILER: 'online retailer',
  PRODUCER: 'producer'
};
